export default "__VITE_ASSET__5q07bi6u__"